import { render, staticRenderFns } from "./HistoricoPeca.vue?vue&type=template&id=7e31093b&scoped=true&"
import script from "./HistoricoPeca.vue?vue&type=script&lang=js&"
export * from "./HistoricoPeca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e31093b",
  null
  
)

export default component.exports